import {FormModalProps} from "../../../utils/useFormModal";
import {Form, Input, InputNumber, Modal} from "antd";

function ModifyModal(props: FormModalProps) {

    const {form, ...otherProps} = props;

    return <Modal width={400} {...otherProps} title={form.getFieldValue('transactionType')==10?'增加样品额度':'减少样品额度'}>
        <Form form={form} layout={'vertical'}>
            <Form.Item name={'dealerId'} noStyle/>
            <Form.Item name={'transactionType'} noStyle/>
            <Form.Item label={'当前样品额度'} name={'amount'}>
                <InputNumber disabled style={{width: '100%'}}/>
            </Form.Item>
            <Form.Item label={'样品额度'} name={'sampleQuota'} rules={[{required: true}]}>
                <InputNumber style={{width: '100%'}} max={form.getFieldValue('transactionType')==20?form.getFieldValue('openingAmount'):undefined}/>
            </Form.Item>
            <Form.Item name={'remark'} label={'备注'} rules={[{required: true}]}>
                <Input.TextArea rows={3}/>
            </Form.Item>
        </Form>
    </Modal>

}

export default ModifyModal;
